import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

const ImageArticle = (props) => {
    const { image, title, url } = props;

    return (
        <a href={url} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
            <div className={styles.imageArticle}>
                <div className={styles.image}>
                    <img src={image} alt="" />
                </div>
                <div className={styles.textPart}>
                    {title}
                </div>
            </div>
        </a>
    );
};

ImageArticle.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string
};

export default ImageArticle;
